import { mapProductBoxPropsFromStaticApi } from "./mapProductBoxPropsFromStaticApi";
export var mapProductBoxesFromStaticApi = function mapProductBoxesFromStaticApi(products) {
  return products.filter(function (product) {
    return product !== null;
  }).map(function (product) {
    return mapProductBoxPropsFromStaticApi(product);
  }).filter(function (product) {
    return product !== null;
  });
};
//# sourceMappingURL=mapProductBoxesFromStaticApi.js.map